import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function FilterIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M2 5.429h8m0 0c0 1.065.895 1.928 2 1.928s2-.863 2-1.928c0-1.066-.895-1.929-2-1.929s-2 .863-2 1.929M6 10.57h8m-8 0c0 1.066-.895 1.929-2 1.929s-2-.864-2-1.929.895-1.928 2-1.928 2 .863 2 1.928" /></svg>
  );
}

export default FilterIcon;
